(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-amla-product"] && !Shopify.designMode) return;
  try {
    
function initAmla(root){
 if(root.dataset.ready)return;
 root.dataset.ready='true';
 const rail=root.querySelector('.aml-slides'),thumbs=[...root.querySelectorAll('[data-slide]')],form=root.querySelector('.aml-form');
 if(!rail||!form)return;
 const reduce=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
 let selected=0,frame=0;
 const mark=i=>{selected=i;thumbs.forEach((b,n)=>b.setAttribute('aria-pressed',String(i===n)));};
 thumbs.forEach((b,i)=>b.addEventListener('click',()=>{mark(i);rail.scrollTo({left:rail.clientWidth*i,behavior:reduce()?'instant':'smooth'});}));
 rail.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>mark(Math.max(0,Math.min(thumbs.length-1,Math.round(rail.scrollLeft/rail.clientWidth)))));},{passive:true});
 rail.addEventListener('keydown',e=>{if(['ArrowRight','ArrowLeft'].includes(e.key)){e.preventDefault();thumbs[Math.max(0,Math.min(thumbs.length-1,selected+(e.key==='ArrowRight'?1:-1)))].click();}});
 const update=()=>{const choice=form.querySelector('[name=quantity]:checked');if(!choice)return;const price=root.querySelector('[data-pack-price="'+choice.value+'"]');if(price.textContent.trim())root.querySelector('[data-total]').textContent=price.textContent;root.querySelector('[data-sticky-supply]').textContent=choice.closest('label').querySelector('.aml-offer-note').textContent.split(' · ')[0];};
 form.addEventListener('change',update);
 const sticky=root.querySelector('[data-sticky]'),buy=root.querySelector('.aml-main-cta');
 let observer;
 const setup=()=>{if(observer)observer.disconnect();const wrapper=root.closest('.page-wrapper');const scrollRoot=wrapper&&getComputedStyle(wrapper).overflowY==='auto'?wrapper:null;observer=new IntersectionObserver(([entry])=>{sticky.hidden=entry.isIntersecting||entry.boundingClientRect.top>=(entry.rootBounds?.top||0);},{root:scrollRoot,threshold:0});observer.observe(buy);};
 setup();let resizeTimer;
 const resize=()=>{clearTimeout(resizeTimer);resizeTimer=setTimeout(()=>{rail.scrollTo({left:rail.clientWidth*selected,behavior:'instant'});setup();},150);};
 window.addEventListener('resize',resize,{passive:true});
 const unload=e=>{if(!e.target.contains(root))return;observer.disconnect();window.removeEventListener('resize',resize);document.removeEventListener('shopify:section:unload',unload);};document.addEventListener('shopify:section:unload',unload);
 root.querySelectorAll('a[href^="#amla-"]').forEach(a=>a.addEventListener('click',e=>{const target=document.getElementById(a.hash.slice(1));if(target){e.preventDefault();target.scrollIntoView({behavior:reduce()?'instant':'smooth',block:'start'});}}));
}
document.querySelectorAll('[data-amla]').forEach(initAmla);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-amla]').forEach(initAmla));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-ortho-reference"] && !Shopify.designMode) return;
  try {
    
(() => {
  const prepared = new WeakSet();
  const prepare = () => document.querySelectorAll('.bw-ortho-reference video').forEach(video => {
    if (prepared.has(video)) return;
    prepared.add(video);
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    video.controls = false;
    let pending = false;
    const resume = () => {
      if (!video.isConnected || document.hidden || !video.paused || pending) return;
      pending = true;
      video.play().catch(() => {}).finally(() => { pending = false; });
    };
    video.addEventListener('canplay', resume);
    video.addEventListener('pause', resume);
    video.addEventListener('ended', resume);
    document.addEventListener('visibilitychange', resume);
    document.addEventListener('pointerdown', resume, { passive: true });
    window.addEventListener('pageshow', resume);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (!video.isConnected) { observer.disconnect(); return; }
        if (entries.some(entry => entry.isIntersecting)) resume();
      });
      observer.observe(video);
    }
    resume();
  });
  prepare();
  document.addEventListener('shopify:section:load', prepare);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-orthoheat-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bw-review-marquee')) {
  customElements.define('bw-review-marquee', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.bw-reviews-viewport');
      this.track = this.querySelector('.review-grid');
      this.button = this.querySelector('.bw-reviews-pause');
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.paused = false;
      this.pauseLabel = this.button.textContent;
      this.hover = false;
      this.focused = false;
      this.touching = false;
      this.visible = false;
      this.holdUntil = 0;
      this.speed = Number(this.dataset.speed) || 25;
      this.originals = [...this.track.children];
      this.originals.forEach(card => {
        const copy = card.cloneNode(true);
        copy.setAttribute('data-marquee-copy', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        this.track.append(copy);
      });
      this.resumeFrame = () => {
        if (this.running && this.visible && !document.hidden && !this.frame) {
          this.last = 0;
          this.frame = requestAnimationFrame(this.tick);
        }
      };
      this.update = () => {
        this.running = this.mobile.matches && !this.reduced.matches && this.dataset.autoplay !== 'false';
        this.toggleAttribute('data-running', this.running);
        this.last = 0;
        this.viewport.scrollLeft = 0;
        this.resumeFrame();
      };
      this.mobile.addEventListener('change', this.update, options);
      this.reduced.addEventListener('change', this.update, options);
      this.button.addEventListener('click', () => {
        this.paused = !this.paused;
        this.button.setAttribute('aria-pressed', String(this.paused));
        this.button.textContent = this.paused ? this.dataset.resumeLabel : this.pauseLabel;
      }, options);
      this.viewport.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') this.hover = true; }, options);
      this.viewport.addEventListener('pointerleave', () => { this.hover = false; }, options);
      this.viewport.addEventListener('focusin', () => { this.focused = true; }, options);
      this.viewport.addEventListener('focusout', () => { this.focused = false; }, options);
      this.viewport.addEventListener('touchstart', () => { this.touching = true; }, { ...options, passive: true });
      const release = () => { this.touching = false; this.holdUntil = performance.now() + 4000; };
      this.viewport.addEventListener('touchend', release, { ...options, passive: true });
      this.viewport.addEventListener('touchcancel', release, { ...options, passive: true });
      this.viewport.addEventListener('wheel', () => { this.holdUntil = performance.now() + 4000; }, { ...options, passive: true });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.resumeFrame();
      });
      this.tick = now => {
        this.frame = 0;
        if (!this.isConnected || !this.visible || !this.running || document.hidden) return;
        const elapsed = this.last ? Math.min(now - this.last, 50) : 0;
        this.last = now;
        if (this.running && !this.paused && !this.hover && !this.focused && !this.touching && now >= this.holdUntil) {
          const first = this.originals[0];
          const copy = this.track.querySelector('[data-marquee-copy]');
          const cycle = copy.offsetLeft - first.offsetLeft;
          if (cycle > 0) {
            this.position = (this.position ?? this.viewport.scrollLeft) + elapsed * this.speed / 1000;
            if (Math.abs(this.viewport.scrollLeft - (this.previousScroll ?? this.viewport.scrollLeft)) > 2) this.position = this.viewport.scrollLeft;
            this.position %= cycle;
            this.viewport.scrollLeft = this.position;
            this.previousScroll = this.viewport.scrollLeft;
          }
        } else { this.position = this.viewport.scrollLeft; this.previousScroll = this.viewport.scrollLeft; }
        this.frame = requestAnimationFrame(this.tick);
      };
      document.addEventListener('visibilitychange', this.resumeFrame, options);
      this.update();
      this.observer.observe(this);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.abort?.abort();
      this.querySelectorAll('[data-marquee-copy]').forEach(copy => copy.remove());
      this.frame = 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
